<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit Game Settings</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Tickets">
        <b-input
          type="number"
          v-model="limit"
          readonly
          disabled
          placeholder="number of tickets"
          required
        ></b-input>
      </b-field>
      <b-field label="Game Type">
        <div class="field">
          <b-checkbox v-model="gameType.corners">Corners</b-checkbox>
          <b-checkbox v-model="gameType.star">Star</b-checkbox>
          <b-checkbox v-model="gameType.top_line">Top Line</b-checkbox>
          <b-checkbox v-model="gameType.middle_line">Mid Line</b-checkbox>
          <b-checkbox v-model="gameType.bottom_line">Bottom Line</b-checkbox>
          <b-checkbox v-model="gameType.early_five">Early Five</b-checkbox>
          <b-checkbox v-model="gameType.early_seven">Early Seven</b-checkbox>
          <b-checkbox v-model="gameType.box_bonus">Box Bonus</b-checkbox>
          <b-checkbox v-model="gameType.half_sheet">Half Shet</b-checkbox>
          <b-checkbox v-model="gameType.full_sheet">Full Shet</b-checkbox>
          <b-checkbox v-model="gameType.fullhouse">First Fullhouse</b-checkbox>
          <b-checkbox v-model="gameType.fullhouse_2"
            >Second Fullhouse</b-checkbox
          >
          <b-checkbox v-model="gameType.fullhouse_3"
            >Third Fullhouse</b-checkbox
          >
        </div>
      </b-field>
      <b-field label="Schedule date and time">
        <b-datetimepicker
          v-model="time"
          :mobile-native="false"
          placeholder="Select a date"
          icon="calendar-today"
          :timepicker="timepicker"
        ></b-datetimepicker>
      </b-field>
    </section>
    <footer v-show="loaded" class="modal-card-foot">
      <button
        v-if="status == 'schedule'"
        @click="edit()"
        class="button is-primary"
      >
        Save
      </button>
      <button
        v-if="status == 'schedule'"
        @click="stopGame()"
        class="button is-warning"
      >
        Cancel Game
      </button>
      <button
        v-if="status == 'stop'"
        @click="duplicate()"
        class="button is-default"
      >
        Reschedule
      </button>
    </footer>
  </div>
</template>

<script>
const date = new Date();
date.setMinutes(0, 0, 0);

export default {
  data() {
    return {
      limit: 600,
      time: date,
      status: "",
      gameId: null,
      loaded: false,
      reschedule: false,
      gameType: {},
      timepicker: {
        incrementMinutes: 15,
        incrementHours: 1,
      },
    };
  },
  methods: {
    setup({ id, data }) {
      this.reschedule = false;
      this.loaded = true;
      if (data) {
        this.gameId = id;
        this.status = data.data.status;
        this.limit = data.data.limit;
        this.time = new Date(data.data.schedule._seconds * 1000);
        if (data.types) {
          this.gameType = data.types;
        }
      }
    },
    stopGame() {
      this.$emit("stopGame", this.gameId);
      this.$parent.close();
    },
    duplicate() {
      this.$buefy.dialog.confirm({
        message: "This game will be reschedule with same tickets.",
        confirmText: "Reschedule Game",
        type: "is-primary",
        onConfirm: () => {
          this.reschedule = true;
          this.edit();
        },
      });
    },
    edit() {
      for (const key in this.gameType) {
        const bool = this.gameType[key];
        if (bool == false) {
          delete this.gameType[key];
        }
      }
      this.$emit("EditGame", {
        gameId: this.gameId,
        time: this.time.getTime(),
        reschedule: this.reschedule,
        gameType: this.gameType,
      });
      this.$parent.close();
    },
  },
};
</script>